import { Dispatch } from 'redux'
import { ThunkAction } from 'redux-thunk'

import { reduxDependenciesType } from '../create'

import { State } from './index'

import config from 'admin/config/main'
import { InvoiceSpecification } from 'admin/types'
import createApiReducer, {
  requestDataFor,
  receiveDataFor,
  handleErrorFor,
  resetDataFor,
} from 'redux/utils/createApiDuck'
import { APIState } from 'types'


const moduleName = `${config.appName  }/invoice`

const submoduleNames = {
  pdf: `${moduleName  }/pdf`,
  excel: `${moduleName  }/excel`,
}

const invoicePDFReducer = createApiReducer(submoduleNames.pdf)

const invoiceSpecificationExcelReducer = createApiReducer(submoduleNames.excel)

export { invoicePDFReducer, invoiceSpecificationExcelReducer }

export default createApiReducer(moduleName)

export function fetchInvoice(
  invoiceId: string,
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())
    return api
      .getInvoice(invoiceId)
      .then(data => {
        dispatch(receiveDataFor(moduleName)(data))
        return data
      })
      .catch(error => {
        dispatch(handleErrorFor(moduleName)(error))
        return Promise.reject(error)
      })
  }
}

export function fetchInvoiceAsPDF(
  invoiceId: string,
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(submoduleNames.pdf)())
    return api
      .getInvoicePDF(invoiceId)
      .then(data => {
        dispatch(receiveDataFor(submoduleNames.pdf)(data))
        return data
      })
      .catch(error => {
        dispatch(handleErrorFor(submoduleNames.pdf)(error))
        return Promise.reject(error)
      })
  }
}

export function fetchInvoiceSpecificationAsExcel(
  invoiceId: string,
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(submoduleNames.excel)())
    return api
      .getInvoiceSpecificationExcel(invoiceId)
      .then(data => {
        dispatch(receiveDataFor(submoduleNames.excel)(data))
        return data
      })
      .catch(error => {
        dispatch(handleErrorFor(submoduleNames.excel)(error))
        return Promise.reject(error)
      })
  }
}

export function resetInvoice() {
  return (dispatch: Dispatch<any, State>) => {
    dispatch(resetDataFor(moduleName)())
    dispatch(resetDataFor(submoduleNames.pdf)())
  }
}

export interface InvoiceState extends APIState {
  data: InvoiceSpecification
}

export interface InvoicePDFState extends APIState {
  data: Blob
  headers: { [key: string]: string }
}

export interface InvoiceSpecificationExcelState extends APIState {
  data: Blob
  headers: { [key: string]: string }
}
